module.exports = __webpack_public_path__ + "img/sml_terms_new_icon.25d500a.png";